import React, { useEffect, useState } from "react";
import { Form, Input, Tabs, Col, Button } from "antd";
import { toast } from "react-toastify";
import { getRequest, postRequest } from "../../api/http";
import userServiceApi from "../../api/userServiceApi";
import { LoadingView } from "../common";
import { useNavigate } from "react-router-dom";
import "./ForgotPassword.scss";
import leftArrow from "../../../src/assets/images/LeftArrow.svg";
import Logo from "../../../src/assets/images/PoweredNew.png";
import { partnerName } from "../../store/constants";

export default function ForgotPasswordForm({ setIsLoginMode }) {
  const [loading, setLoading] = useState(false);
  const [partnerData, setPartnerData] = useState({});
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const partnerID = localStorage.getItem("partnerID");

  const getPartnerDetailsData = async (partnerID) => {
    try {
      // setLoading(true);
      // const response = await getRequest(userServiceApi.getPartnerDetailsLoginScreen(partnerID));
      const response = await getRequest(userServiceApi.getPartnerDetailsLoginScreen(partnerName));


      if (response && response.data) {
        setPartnerData(response.data);
      }
    } catch (error) {
      // setLoading(false);
      toast.error(error.error);
    }
  };

  useEffect(() => {
    getPartnerDetailsData(partnerID);
  }, [])

  const onFinish = async (values) => {
    const payload = {
      ...values,
      userRole: 'ORGANIZATION_ADMIN'
    }
    setLoading(true);
    try {
      const response = await postRequest(
        userServiceApi.forgotPassword(),
        payload
      );
      if (response === "success") {
        toast.success("Reset link has been sent to your mail");
        setLoading(false);
        navigate(`/login/${partnerID}`);
      } else {
        setLoading(false);
      }
    } catch (error) {
      toast.error(error.message);
      setLoading(false);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.error("Failed:", errorInfo);
  };

  return (
    <React.Fragment>


      <div className="changepassword-page">
        <div className="header-container">
          <div className="partner-header">
            <div
              className="heading-backBtn"
              onClick={() => {
                navigate("/SuperAdmin");
              }}
            >
              <img src={leftArrow} alt="leftarrow" />
              <p>Reset password</p>
            </div>
          </div>
        </div>


        <div className=" custom">
          <div className="forgotPassword">
            <Form
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              layout="vertical"
            >
              {/* <div
            style={{ color: "black", fontSize: "18px" }}
            className="changePwdHeading"
          >
            Change Password
          </div> */}
              <div className="forgotPasswordForm">
                <div className="formRow">
                  <div className="formCol">
                    <Form.Item
                      label="Email"
                      name="email"
                    normalize={(value) => value?.trim()}
                      rules={[{ required: true, message: "Email is required" }]}
                    >
                      <Input placeholder="Email" />
                    </Form.Item>
                  </div>
                  <div className="formCol">
                    <Button
                      className="cancelBtn"
                      onClick={() => {
                        navigate(`/login/${partnerID}`);
                      }}
                    >
                      Cancel
                    </Button>
                    <Button className="greenBtn" htmlType="submit">
                      Request Reset Link
                    </Button>
                  </div>
                  <div className="formCol"></div>
                </div>
              </div>

            </Form>
          </div>
          <div className="footerlogo">
            <img
              style={{ cursor: "pointer", width: "100px", marginTop: "15px" }}
              src={Logo}
              alt=""
            />
          </div>
        </div>
      </div>


    </React.Fragment >
  );
}
